// extracted by mini-css-extract-plugin
export default {"item":"FloorSelectorItem-module--item--5276e","label":"FloorSelectorItem-module--label--fda2d","tools":"FloorSelectorItem-module--tools--01933"};